import { z } from 'zod';
import { TimestampSchema } from './common';
import { DestinationSchema, ProgressStatusSchema } from './enums';

/**
 * A physical box / container / bin / bag (PRD §8.12, §15.7). Items reference
 * a box by id (`item.boxId`).
 */
export const BoxSchema = z.object({
  id: z.string().min(1),
  name: z.string().trim().min(1).max(120),

  /** Enum room key or custom room string. */
  room: z.string().trim().min(1).optional(),
  destination: DestinationSchema.optional(),
  progressStatus: ProgressStatusSchema.optional(),
  storageLocation: z.string().trim().max(120).optional(),
  notes: z.string().trim().max(2000).optional(),

  /** Reserved — QR labels are a V2 feature (PRD §11.5). */
  qrCodeUrl: z.string().url().optional(),

  createdAt: TimestampSchema,
  updatedAt: TimestampSchema,
});
export type Box = z.infer<typeof BoxSchema>;

export const BoxDraftSchema = BoxSchema.omit({
  id: true,
  qrCodeUrl: true,
  createdAt: true,
  updatedAt: true,
});
export type BoxDraft = z.infer<typeof BoxDraftSchema>;
